module.exports = __webpack_public_path__ + "static/logoFull-3e6c82f73bb3b9788c2054e6a0f58111.gif";